<template>
  <div style="height: 100vh; width: 100vw; overflow-y: hidden">
    <div @mouseleave="isAirConditionerShow = false">
      <el-collapse-transition>
        <AirConditioner v-show="isAirConditionerShow"/>
      </el-collapse-transition>
    </div>
    <el-scrollbar style="height: 100%; width: 100vw" wrap-style="overflow-x:hidden;">
      <!-- <div class="nav_top_style dark:bg-gray-900"     -->

      <div class="nav_top_style"
      >
        <div class="nav_title">
          <div class="flex" style="justify-content: space-between; align-items: center;">
            <div class="flex" style="flex-direction: row;align-items: center;justify-content: flex-start;">
              <img src="/favicon.ico" width="20" height="20"/>
              <span class="nav_title_name">梦想时光门-金唐分门</span>
            </div>
            <div style="display: flex;align-items: center;justify-content: flex-end; height: 50px;">
              <div style="cursor: pointer" @mouseover="isAirConditionerShow = true">
                <svg t="1718946443186" class="icon" viewBox="0 0 1286 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1667" width="32" height="32"><path d="M190.98544 915.420101h99.06242v95.459117H190.98544zM1030.255377 915.420101h99.06242v95.459117h-99.06242z" fill="#F0F0FF" p-id="1668"></path><path d="M1257.299703 850.24528c0 55.15071-45.126598 100.272138-100.272138 100.272138H153.153335c-55.15071 0-100.277308-45.126598-100.277308-100.272138V133.255033c0-55.15071 45.126598-100.277308 100.277308-100.277307h1003.87423c55.15071 0 100.272138 45.126598 100.272138 100.277307v716.990247z" fill="#F0F0FF" p-id="1669"></path><path d="M1159.152325 875.313314h-468.507037c113.19647-64.719885 189.543084-186.53947 189.543084-326.267009 0-207.471718-168.192088-375.663806-375.668975-375.663805s-375.668976 168.192088-375.668976 375.663805c0 139.727539 76.346614 261.552293 189.543085 326.267009H155.283265c-55.15071 0-100.277308-45.126598-100.277308-100.277308v75.209274c0 55.15071 45.126598 100.272138 100.277308 100.272138h1003.86906c55.15588 0 100.277308-45.126598 100.277308-100.272138v-75.209274c0 55.15071-45.121428 100.277308-100.277308 100.277308z" fill="#6E6E96" opacity=".15" p-id="1670"></path><path d="M969.386942 176.903088h188.85551v40.111957h-188.85551z" fill="#6E6E96" p-id="1671"></path><path d="M503.242473 500.704134m-352.213898 0a352.213898 352.213898 0 1 0 704.427795 0 352.213898 352.213898 0 1 0-704.427795 0Z" fill="#C8C8E0" p-id="1672"></path><path d="M835.402977 500.709303c0 183.142955-149.007209 332.155334-332.160504 332.155335s-332.160504-149.012379-332.160504-332.155335c0-183.153295 149.007209-332.160504 332.160504-332.160504s332.160504 149.00204 332.160504 332.160504z m-332.160504-372.272461c-205.274581 0-372.272461 167.003049-372.272461 372.272461s166.99271 372.262122 372.272461 372.262122c205.264242 0 372.272461-166.99788 372.272461-372.262122 0-205.274581-167.008219-372.272461-372.272461-372.272461z" fill="#6E6E96" p-id="1673"></path><path d="M1163.944668 32.755427H160.075607c-55.15071 0-100.277308 45.126598-100.277307 100.277308v75.209273c0-55.15071 45.126598-100.277308 100.277307-100.277308h1003.869061c55.15071 0 100.277308 45.126598 100.277307 100.277308V133.032735c0-55.15588-45.126598-100.277308-100.277307-100.277308z" fill="#FFFFFF" opacity=".53" p-id="1674"></path><path d="M1237.246309 850.24528c0 44.237404-35.99685 80.223914-80.229083 80.223914H153.153335c-44.237404 0-80.229084-35.98651-80.229084-80.223914V133.255033c0-44.232234 35.98651-80.223914 80.229084-80.223914h1003.87423c44.232234 0 80.229084 35.99168 80.229084 80.223914l-0.01034 716.990247z m40.111958-716.990247c0-66.348351-53.98235-120.330701-120.330702-120.330701H153.153335C86.804984 12.924332 32.822634 66.906682 32.822634 133.255033v716.985077c0 66.348351 53.98235 120.330701 120.330701 120.330701h1003.87423c66.348351 0 120.330701-53.98235 120.330702-120.330701V133.255033z" fill="#6E6E96" p-id="1675"></path><path d="M505.749793 503.211454m-277.009794 0a277.009794 277.009794 0 1 0 554.019588 0 277.009794 277.009794 0 1 0-554.019588 0Z" fill="#C8C8E0" p-id="1676"></path><path d="M503.066702 509.135968m-72.944931 0a72.94493 72.94493 0 1 0 145.889861 0 72.94493 72.94493 0 1 0-145.889861 0Z" fill="#B3E3FF" p-id="1677"></path><path d="M504.307438 297.259638c133.50835 0 243.365173 101.166502 257.15285 231.02502 0.96674-9.078051 1.483713-18.280175 1.483713-27.616712 0-142.839718-115.796846-258.636564-258.636563-258.636564-142.844888 0-258.646903 115.796846-258.646904 258.636564 0 9.341707 0.527313 18.538662 1.488883 27.616712C260.926755 398.426139 370.793917 297.259638 504.307438 297.259638z" fill="#6E6E96" opacity=".36" p-id="1678"></path><path d="M1126.614027 680.016317h41.357863v144.752519h-41.357863zM969.800521 680.016317h41.357863v144.752519h-41.357863zM1049.068034 680.016317h41.357863v144.752519h-41.357863z" fill="#6E6E96" p-id="1679"></path></svg>
              </div>
              <ThemeToggle></ThemeToggle>
              <WeekView></WeekView>
<!--              <BitoChatIcon></BitoChatIcon>-->
              <DocSearch></DocSearch>
            </div>
          </div>
          <!--
          <i :class="leftNav ? 'el-icon-refresh-right' : 'el-icon-refresh-left'"
             @click="toggleStyle"
             style="font-size: 20px;
                   margin: 5px;
                   cursor: pointer"></i>-->
        </div>
        <div class="nav_main">
          <InfoNav></InfoNav>
          <div style="margin-bottom: 10px; display: flex; justify-content: center; align-items: center">
            <a href="//beian.miit.gov.cn" target="_blank">
              <img src="//imgi.xinnet.com/static/xinnet/images/d0289dc0a46fc5b15b3363ffa78cf6c7.png"
                   style="display: inline"/>浙ICP备20029736号-1
            </a>
            <img src="https://visitor-badge.laobi.icu/badge?page_id=kingdragon.nav&title=Total%20Visits"
                 style="display: inline; margin-left: 10px">
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>

</template>

<script>
import InfoNav from "./components/InfoNav";
import BitoChat from "@/components/bito/BitoChat.vue";
import DocSearch from "@/components/algolia/DocSearch.vue";
import BitoChatIcon from "@/components/bito/BitoChatIcon.vue";
import ThemeToggle from "@/components/ThemeToggle.vue";
import WeekView from "@/components/WeekView.vue";
import AirConditioner from "@/components/air-conditioner/AirConditioner.vue";

export default {
  name: 'App',
  components: {
    AirConditioner,
    WeekView,
    ThemeToggle,
    BitoChatIcon,
    DocSearch,
    BitoChat,
    InfoNav
  },
  created() {
  },
  data() {
    return {
      isAirConditionerShow: false,
      leftNav: false,
      darkStyle: false,
      navData: [],
      screenWidth: 0,
      screenHeight: 0
    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="scss">

.el-popper[x-placement^=bottom] .popper__arrow::after {
  top: 0 !important;
  border-bottom-color: var(--el-popover-bg-color) !important;
}


</style>
